import html2pdf from "html2pdf.js";
import { useEffect, useState } from "react";
import logo from "../../assets/SelfSync Logo.png";
import bronzemedal from "../../assets/medals/brownz.png";
import goldmedal from "../../assets/medals/goldmedal.png";
import silvermedal from "../../assets/medals/silvermedal.png";
import html2canvas from "html2canvas";

// Reusable content
const CertificateLayout = ({
  certificateDetails = {},
  medal,
  id = "certificate",
  className = "",
}) => {
  const {
    name = "",
    score = "",
    issue_date = "",
    id: certId = "",
  } = certificateDetails;
  return (
    <div
      id={id}
      className={`relative overflow-hidden rounded-lg border-[5px] border-transparent bg-gradient-to-br from-white/90 to-indigo-100 ${className}`}
    >
      {/* Corner Decorations */}
      {["top-left", "top-right", "bottom-left", "bottom-right"].map((pos) => (
        <div
          key={pos}
          className={`absolute w-[100px] h-[100px] bg-no-repeat bg-contain ${
            pos === "top-left"
              ? "top-0 -left-4"
              : pos === "top-right"
              ? "top-0 -right-8"
              : pos === "bottom-left"
              ? "-bottom-8 -left-4"
              : "-bottom-8 -right-8"
          }`}
          style={{
            backgroundImage: `url("${cornerSVGs[pos]}")`,
          }}
        />
      ))}

      {/* Watermark */}
      <div className="absolute top-[30%] left-[5%] opacity-5 text-[200px] font-bold text-[#3a0ca3] rotate-[-30deg] whitespace-nowrap z-0">
        SelfSync.ai
      </div>

      {/* Main Content */}
      <div className="h-full flex flex-col items-center justify-center text-center relative z-10 px-4 sm:px-10 py-12">
        {/* Badge SVG */}
        <div className="mb-6">
          <svg
            width="120"
            height="120"
            viewBox="0 0 120 120"
            className="mx-auto px-1"
          >
            <circle
              cx="60"
              cy="60"
              r="55"
              fill="none"
              stroke="#f72585"
              strokeWidth="3"
            />
            <circle
              cx="60"
              cy="60"
              r="45"
              fill="none"
              stroke="#7209b7"
              strokeWidth="2"
              strokeDasharray="5,5"
            />
            <text
              x="60"
              y="65"
              textAnchor="middle"
              fontFamily="Playfair Display"
              fontSize="12"
              fill="#3a0ca3"
            >
              CERTIFICATE
            </text>
          </svg>
        </div>

        <h2
          className="text-3xl sm:text-4xl font-bold mb-6 text-purple-700"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          Participation Excellence Award
        </h2>

        <p className="text-gray-600 text-lg mb-2 uppercase tracking-wider">
          This certificate is proudly presented to
        </p>

        <div className="relative my-4 px-8">
          <div className="absolute top-0 left-0 w-full h-[2px] bg-gradient-to-r from-transparent via-purple-500 to-transparent z-0" />
          <h3
            className="text-3xl sm:text-5xl font-bold py-4 text-blue-700 relative z-10"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            {name}
          </h3>
          <div className="absolute bottom-0 left-0 w-full h-[2px] bg-gradient-to-r from-transparent via-purple-500 to-transparent z-0" />
        </div>

        <p className="text-gray-600 mt-4">
          in recognition of their active participation in
        </p>

        <div className="my-8 max-w-2xl">
          <h4 className="text-2xl sm:text-3xl font-bold text-purple-700 mb-4">
            Personality Assessment Powered By SelfSync.ai
          </h4>
          <p className="text-gray-700 text-lg italic px-2 sm:px-0">
            "For demonstrating exceptional engagement and a strong commitment to
            personal growth through our comprehensive personality assessment
            program"
          </p>
        </div>

        <div className="flex justify-between items-center w-full max-w-2xl mt-12 px-4 sm:px-0">
          <div className="text-center">
            <img src={logo} className="h-20 w-auto mb-4 max-md:h-12" />
          </div>
          <div className="text-center">
            <img
              src={medal.src}
              alt={medal.title}
              className="w-24 h-24 sm:w-28 sm:h-28 mx-auto"
            />
          </div>
          <div className="text-center">
            <p className="text-gray-600">Date of Completion</p>
            <p className="text-sm font-medium text-gray-700">{issue_date}</p>
          </div>
        </div>

        <div className="mt-6 pb-10 flex justify-center items-center">
          <p className="text-gray-500 text-sm">
            Certificate Id:{" "}
            <span className="font-mono text-purple-700 ">SA-{certId}</span>
          </p>
        </div>
      </div>
    </div>
  );
};

const CertificatePopup = ({ certificateDetails, onClose }) => {
  const [medal, setMedal] = useState({ src: "", title: "", className: "" });

 useEffect(() => {
  const score = parseFloat(certificateDetails?.score || 0);

  if (score >= 6.0) {
    setMedal({
      src: goldmedal,
      title: "GOLD AWARD",
      className: "text-amber-600",
    });
  } else if (score >= 5.0) {
    setMedal({
      src: silvermedal,
      title: "SILVER AWARD",
      className: "text-gray-500",
    });
  } else {
    setMedal({
      src: bronzemedal,
      title: "BRONZE AWARD",
      className: "text-amber-700",
    });
  }
}, [certificateDetails]);


  const downloadAsPDF = () => {
    const certificate = document.getElementById("certificate-download");
    html2pdf()
      .from(certificate)
      .set({
        margin: 0,
        filename: "SelfSync_Certificate.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true, backgroundColor: null },
        jsPDF: { unit: "in", format: "letter", orientation: "landscape" },
      })
      .save();
  };
  const downloadAsImage = () => {
    const certificate = document.getElementById("certificate-download");
    html2canvas(certificate, {
      scale: 2,
      useCORS: true,
      backgroundColor: null,
    }).then((canvas) => {
      const link = document.createElement("a");
      link.download = "SelfSync_Certificate.png";
      link.href = canvas.toDataURL("image/png");
      link.click();
    });
  };

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto ">
      <div className="flex items-center justify-center min-h-screen  pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        {/* Background overlay */}
        <div
          className="fixed inset-0 transition-opacity"
          aria-hidden="true"
          onClick={onClose}
        >
          <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

        {/* Modal container */}
        <div className="inline-block align-bottom  text-left md:max-w-5xl my-4 rounded-3xl transform transition-all  sm:align-middle sm:max-w-4xl sm:w-full">
          {/* Certificate content */}
          <div className="flex justify-center items-center flex-col">
            {/* Visible Responsive Certificate */}
            <CertificateLayout
              id="certificate"
              certificateDetails={certificateDetails}
              medal={medal}
              className="w-full max-w-[11in] md:aspect-[11/8.5] bg-white"
            />

            {/* Hidden fixed-dimension Certificate for export */}
            <div className="absolute left-[-9999px] top-[-9999px]">
              <CertificateLayout
                id="certificate-download"
                certificateDetails={certificateDetails}
                medal={medal}
                className="w-[11in] h-[8.5in]"
              />
            </div>
          </div>

          {/* Action buttons */}
          <div className="bg-transparent mt-4  justify-center flex  ">
            <div className="flex gap-4">
              {/* <button
                onClick={downloadAsImage}
                className="bg-purple-600 hover:bg-purple-700 text-white font-semibold px-6 py-2 rounded-lg shadow-lg transition-all duration-200"
              >
                Download as Image
              </button> */}
              <button
                onClick={downloadAsPDF}
                className="bg-violet-600 ml-6 max-md:ml-0 hover:bg-violet-700 text-white font-semibold px-6 max-md:px-4 py-2 rounded-full shadow-lg transition-all duration-200"
              >
                Download as PDF
              </button>
            </div>
            <button
              type="button"
              className="mt-3 max-md:mt-0 max-md:ml-2 w-full max-md:w-40 inline-flex justify-center rounded-full border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
              onClick={onClose}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const cornerSVGs = {
  "top-left":
    "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><path fill='%23f72585' d='M100,0 L0,0 L0,100 C20,80 40,100 60,80 C80,60 100,80 100,100 Z'/></svg>",
  "top-right":
    "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><path fill='%234cc9f0' d='M0,0 L100,0 L100,100 C80,80 60,100 40,80 C20,60 0,80 0,100 Z'/></svg>",
  "bottom-left":
    "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><path fill='%237209b7' d='M100,100 L0,100 L0,0 C20,20 40,0 60,20 C80,40 100,20 100,0 Z'/></svg>",
  "bottom-right":
    "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><path fill='%234361ee' d='M0,100 L100,100 L100,0 C80,20 60,0 40,20 C20,40 0,20 0,0 Z'/></svg>",
};

export default CertificatePopup;
